export class ConfigError extends Error {
  constructor(message: string) {
    super(`CONFIG ERROR: ${message}`)
  }
}
